import {Component, OnInit, ViewChild} from '@angular/core';

import {language} from '../../../language/vn';
import {BsModalService} from 'ngx-bootstrap/modal';
import {DatePipe} from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import {WeekService} from '../../../service/calendar/service-week';
import {CommandUtil} from '../../../global/commandutil';
import {FormatService} from '../../../service/format/service-format';
import {environment} from '../../../../environments/environment';
import {NhomVanBanDi} from '../../../models/vanbandi/nhomvanbandi';
import {LoaiVanBan} from '../../../models/danhmuc/loaivanban';
import {LinhVucVanBan} from '../../../models/danhmuc/linhvucvanban';
import {NhomVanBanDiService} from '../../../service/vanbandi/service-nhomvanbandi';
import {LoaiVanBanService} from '../../../service/danhmuc/service-loaivanban';
import {LinhVucVanBanService} from '../../../service/danhmuc/service-linhvucvanban';
import {GroupOTherComponent} from '../groupother/groupother.component';
import {GroupSelectComponent} from '../group/groupselect.component';
import {forEach} from 'ag-grid-community/dist/lib/utils/array';
import {VanBanDenService} from '../../../service/vanbanden/service-vanbanden';
import {VanBanDiService} from '../../../service/vanbandi/service-vanbandi';
import {VanBanDen} from '../../../models/vanbanden/vanbanden';
import {VanBanDi} from '../../../models/vanbandi/vanbandi';
import {ChenHoSoVanBanDenComponent} from '../vanbanden/chenhoso/chenhoso.component';
import {ChenHoSoVanBanDiComponent} from '../vanbandi/chenhoso/chenhoso.component';
import {LogSearchComponent} from './logsearch.component';
import {LogSearch} from '../../../models/search/logsearch';
import {Sessioncommand} from '../../../global/sessioncommand';
import {LogSearchService} from '../../../service/search/service-logsearch';
import {StaffsService} from '../../../service/staff/service-staffs';
import {SelectStaffComponent} from '../../ui/selectstaff/selectstaff.component';
@Component({
  templateUrl: './search.component.html'
})
export class SearchComponent implements OnInit {
  public language= language;
  public dataCheck: Object[]=[];
  public srFromDate: Date = null ;
  public srToDate: Date = null;
  public srFromDateDi: Date = null ;
  public srToDateDi: Date = null;
  public strF: string= '';
  public strT: string= '';
  public strFDi: string= '';
  public strTDi: string= '';
  public srNoiDungDen: string='';
  public srSoVanBan: string='';
  public srNguoiKy: string='';
  public srLoaiVanBan: number = -1;
  public srLinhVuc: number =-1;
  public srTextLoaiVanBan : string = '';
  public srTextLinhVuc : string = '';
  public staffSingerList: Object[]=[];
  public selectedSingerList: Object[]=[];
  public srNoiDungDi: string='';
  public srSoVanBanDi: string='';
  public srNguoiKyDi: string='';
  public srNhomVanBan: number = -1;
  public srTextNhomVanBan: string = '';
  public srLoaiVanBanDi: number = -1;
  public srTextLoaiVanBanDi: string = '';
  public srLinhVucDi: number =-1;
  public srTextLinhVucDi: string = '';

  public dataNhomVanBan: NhomVanBanDi[] =[];
  public dataLoaiVanBan: LoaiVanBan[] = [];
  public dataLinhVuc: LinhVucVanBan[] = [];
  public totalVanBanDen: number =0;
  public totalVanBanDi: number =0;
  public dataVanBanDen: VanBanDen[] = [];
  public dataVanBanDi: VanBanDi[] =[];
  public srNoiPhatHanh: string= "-1";
  public stTimKiemVBDen: boolean = false;
  public stTimKiemVBDi: boolean = false;
  @ViewChild("selectGroup")
  public selectGroup: GroupOTherComponent;
  @ViewChild(SelectStaffComponent)
  public uiSelectStaff: SelectStaffComponent;
  public totalItems: number = 0;
  public currentPage: number   = environment.currentPage;
  public currentPageDi: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public numPagesDi: number = environment.numberPages;

  ngOnInit(): void {

    this.nhomVanBanDiService.getAll().subscribe(data => this.dataNhomVanBan = data);
    this.loaiVanBanService.getAll().subscribe(data => this.dataLoaiVanBan = data);
    this.linhVucVanBanService.getAll().subscribe(data => this.dataLinhVuc = data);
    Sessioncommand.sideBarActive = true;
  }

  searchVBDI()
  {
    if(this.stTimKiemVBDi === true) {
      this.strFDi = this.srFromDateDi !== null &&  !isNaN(this.srFromDateDi.getTime()) ? this.datePipe.transform(this.srFromDateDi, 'MM/dd/yyyy') : '';
      this.strTDi = this.srToDateDi !== null && !isNaN(this.srToDateDi.getTime()) ? this.datePipe.transform(this.srToDateDi, 'MM/dd/yyyy') : '';
      let selectSingers: string = this.uiSelectStaff.selected.length > 0 ? this.uiSelectStaff.selected.join() : '-1';
      this.vanBanDiService.getCountBySearch(Sessioncommand.staffId, this.srNoiDungDi,
        this.srSoVanBanDi, this.srNhomVanBan, this.srLoaiVanBanDi, this.srLinhVucDi, '-1',
        selectSingers, this.strFDi, this.strTDi).subscribe(data => this.totalVanBanDi = data);
      this.vanBanDiService.findAllByPagingSearch(Sessioncommand.staffId, this.srNoiDungDi,
        this.srSoVanBanDi, this.srNhomVanBan, this.srLoaiVanBanDi, this.srLinhVucDi, '-1',
        selectSingers, this.strFDi, this.strTDi, this.currentPageDi, this.maxSize).subscribe(data => this.dataVanBanDi = data);
    }else
    {
      this.vanBanDiService.getCountBySearch(Sessioncommand.staffId,this.srNoiDungDi,
        '', -1, -1, -1, '-1',
        '-1', 'null', 'null').subscribe(data => this.totalVanBanDi = data);
      this.vanBanDiService.findAllByPagingSearch(Sessioncommand.staffId, this.srNoiDungDi,
        '', -1, -1, -1, '-1',
        '-1', 'null', 'null', this.currentPageDi, this.maxSize).subscribe(data => this.dataVanBanDi = data);
    }
  }
  searchVBD()
  {

    this.strF = this.srFromDate !== null && !isNaN(this.srFromDate.getTime())  ? this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy') : '';
    this.strT = this.srToDate !== null && !isNaN(this.srToDate.getTime()) ? this.datePipe.transform(this.srToDate, 'MM/dd/yyyy') : '';
    if(this.stTimKiemVBDen === true) {
      this.vanBanDenService.getCountBySearch(Sessioncommand.staffId, this.srNoiDungDen,
        this.srSoVanBan, this.srLoaiVanBan, this.srLinhVuc, '-1',
        (this.selectGroup.selectTree.value.length > 0 ? this.selectGroup.selectTree.value.join() : '-1'), this.strF, this.strT).subscribe(data => this.totalVanBanDen = data);
      this.vanBanDenService.findAllByPagingSearch(Sessioncommand.staffId, this.srNoiDungDen,
        this.srSoVanBan, this.srLoaiVanBan, this.srLinhVuc, '-1',
        (this.selectGroup.selectTree.value.length > 0 ? this.selectGroup.selectTree.value.join() : '-1'), this.strF, this.strT, this.currentPage, this.maxSize).subscribe(data => this.dataVanBanDen = data);
    }else
    {
      this.vanBanDenService.getCountBySearch(Sessioncommand.staffId, this.srNoiDungDen,
        '', -1, -1, '-1',
       '-1', 'null', 'null').subscribe(data => this.totalVanBanDen = data);
      this.vanBanDenService.findAllByPagingSearch(Sessioncommand.staffId, this.srNoiDungDen,
        '', -1, -1, '-1',
        '-1', null, null, this.currentPage, this.maxSize).subscribe(data => this.dataVanBanDen = data);
    }
  }
  constructor(

    public bsModalService: BsModalService,
    public datePipe: DatePipe,
    public toastr: ToastrService,
    public commandUtil: CommandUtil,
    public formatService: FormatService,
    public nhomVanBanDiService: NhomVanBanDiService,
    public loaiVanBanService: LoaiVanBanService,
    public linhVucVanBanService: LinhVucVanBanService,
    public vanBanDenService: VanBanDenService,
    public vanBanDiService: VanBanDiService,
    public logSearchService: LogSearchService,
    public staffsService: StaffsService

  ) {

  }

  public showSearchLog(type: string) {
    const modalEdit = this.bsModalService.show(LogSearchComponent, {class: 'modal-lg'});
    (<LogSearchComponent>modalEdit.content).edit(
      type
    );
    (<LogSearchComponent>modalEdit.content).onClose.subscribe(result => {

    });
    (<LogSearchComponent>modalEdit.content).selectSearch.subscribe(result => {
        if(result!=null && result!=='')
        {
          let paramSearch = JSON.parse(result);
          if(type==='VBDEN') {
            this.srNoiDungDen = paramSearch.srNoiDungDen;
            this.srFromDate = paramSearch.strF !== null ? new Date(paramSearch.strF) : null;
            this.srToDate = paramSearch.strT !== null ? new Date(paramSearch.strT) : null;
            this.srSoVanBan = paramSearch.srSoVanBan;
            this.srNguoiKy = paramSearch.srNguoiKy;
            this.srLoaiVanBan = Number(paramSearch.srLoaiVanBan);
            this.srLinhVuc = Number(paramSearch.srLinhVuc);
            if(paramSearch.srNoiPhatHanh!=null && paramSearch.srNoiPhatHanh!=='')
                this.selectGroup.selectTree.value= paramSearch.srNoiPhatHanh.split(',');
            this.searchVBD();
          }
          if(type ==='VBDI') {
            this.srNoiDungDi = paramSearch.srNoiDungDi;
            this.srFromDateDi = paramSearch.strF !== null ? new Date(paramSearch.strF) : null;
            this.srToDateDi = paramSearch.strT !== null ? new Date(paramSearch.strT) : null;
            this.srSoVanBanDi = paramSearch.srSoVanBan;
            this.srNhomVanBan = paramSearch.srNhomVanBan;
            this.srLoaiVanBanDi = Number(paramSearch.srLoaiVanBan);
            this.srLinhVucDi = Number(paramSearch.srLinhVuc);
            if(paramSearch.selectSingers!== null && paramSearch.selectSingers!=='') {
              this.staffsService.findAllByStaffId(paramSearch.selectSingers ).subscribe( data => {
                for (let i = 0; i < data.length; i++) {
                  if (this.staffSingerList.some(e => e["id"] === data[i].id) == false) {
                    this.staffSingerList = [...this.staffSingerList, {id: data[i].id, fullName: data[i].fullName}];
                    this.selectedSingerList = [...this.selectedSingerList, data[i].id];
                  }
                }
              });

            }
            this.searchVBDI();
          }
        }
    });

  }
  public saveLogVB(type: string)
  {
      let logSearch: LogSearch = new   LogSearch();
          logSearch.searchForm = type;
          logSearch.staffId = Sessioncommand.staffId;
          if(type === 'VBDEN') {
            let strF1: string  = this.srFromDate !== null && !isNaN(this.srFromDate.getTime())  ? this.datePipe.transform(this.srFromDate, 'dd/MM/yyyy') : '';
            let strT1: string  = this.srToDate !== null && !isNaN(this.srToDate.getTime()) ? this.datePipe.transform(this.srToDate, 'dd/MM/yyyy') : '';
            logSearch.keyWord = language.noidung + '=' + this.srNoiDungDen + ',' + language.tungay + '=' + strF1 + ',' + language.denngay + '=' + strT1 + ',' + language.sovanban
              + '=' + this.srSoVanBan + ',' + language.nguoiky + '=' + this.srNguoiKy + ',' + language.loaivanban + '=' + this.srTextLoaiVanBan + ',' + language.tenlinhvuc + '=' + this.srTextLinhVuc  ;
             strF1 = this.srFromDate !== null && !isNaN(this.srFromDate.getTime())  ? this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy') : '';
             strT1 = this.srToDate !== null && !isNaN(this.srToDate.getTime()) ? this.datePipe.transform(this.srToDate, 'MM/dd/yyyy') : '';
            logSearch.paramSearch = '{"srNoiDungDen":"' + this.srNoiDungDen + '","strF":"' + strF1 + '","strT":"' + strT1 + '",'
              + '"srSoVanBan":"' + this.srSoVanBan + '","srNguoiKy":"' + this.srNguoiKy + '","srLoaiVanBan":"' + this.srLoaiVanBan.toString() + '"'
              + ',"srLinhVuc":"' + this.srLinhVuc.toString() + '","srNoiPhatHanh":"' + (this.selectGroup.selectTree.value.length > 0 ? this.selectGroup.selectTree.value.join() : '-1' ) + '"}';
          }
          if(type === 'VBDI') {
            let strDiF1: string  = this.srFromDateDi !== null && !isNaN(this.srFromDateDi.getTime())  ? this.datePipe.transform(this.srFromDateDi, 'dd/MM/yyyy') : '';
            let strDiT1: string  = this.srToDateDi !== null && !isNaN(this.srToDateDi.getTime()) ? this.datePipe.transform(this.srToDateDi, 'dd/MM/yyyy') : '';
            logSearch.keyWord =  language.noidung + '=' + this.srNoiDungDi + ',' + language.tungay + '=' + strDiF1 + ',' + language.denngay + '=' + strDiT1 + ',' + language.sovanban
              + '=' + this.srSoVanBanDi + ',' + language.nguoiky + '=' + (this.staffSingerList.length > 0 && this.uiSelectStaff.selected.length > 0 ? this.staffSingerList.filter(k => this.uiSelectStaff.selected.findIndex( t => t === k["id"]) !== -1).map( x => x['fullName'] ).join(',') : '') + ',' + language.loaivanban + '=' + this.srTextLoaiVanBanDi + ',' + language.tenlinhvuc + '=' + this.srTextLinhVucDi + ','
              + language.nhomvanban + '=' + this.srTextNhomVanBan   ;
            strDiF1 = this.srFromDateDi !== null && !isNaN(this.srFromDateDi.getTime())  ? this.datePipe.transform(this.srFromDateDi, 'MM/dd/yyyy') : '';
            strDiT1 = this.srToDateDi !== null && !isNaN(this.srToDateDi.getTime()) ? this.datePipe.transform(this.srToDateDi, 'MM/dd/yyyy') : '';
            logSearch.paramSearch = '{"srNoiDungDi":"' + this.srNoiDungDi + '","strF":"' + strDiF1 + '","strT":"' + strDiT1 + '",'
              + '"srSoVanBan":"' + this.srSoVanBanDi + '","srNhomVanBan":"' + this.srNhomVanBan + '","srLoaiVanBan":"' + this.srLoaiVanBanDi.toString() + '"'
              + ',"srLinhVuc":"' + this.srLinhVucDi.toString() + '","selectSingers":"' + (this.uiSelectStaff.selected.length > 0 ? this.uiSelectStaff.selected.join():'-1') + '"}';
          }
          this.logSearchService.add(logSearch).subscribe({
            next: () => {

            },
            error: error => {

            }
          });
  }
  public showSinger()
  {
    const modalEdit = this.bsModalService.show(GroupSelectComponent, {class: 'modal-lg'});
    (<GroupSelectComponent>modalEdit.content).showDonVi(
      this.staffSingerList
    );
    (<GroupSelectComponent>modalEdit.content).selectStaffs.subscribe(result => {
      if(result != null && result.length >= 1)
      {

        for(let i=0; i< result.length;i++)
        {
          if(this.staffSingerList.some(e => e["id"] === result[i].id)==false) {

            this.staffSingerList= [...this.staffSingerList, {id: result[i].id, fullName: result[i].fullName}];
            this.selectedSingerList=[...this.selectedSingerList, result[i].id];
          }
        }

      }
    });
  }
  public chenHoSoVBDen(id: number) {
    const modalEdit = this.bsModalService.show(ChenHoSoVanBanDenComponent, {class: 'modal-lg'});
    (<ChenHoSoVanBanDenComponent>modalEdit.content).edit(
      id
    );
    (<ChenHoSoVanBanDenComponent>modalEdit.content).onClose.subscribe(result => {

    });

  }
  public chenHoSoVBDi(id: number) {
    const modalEdit = this.bsModalService.show(ChenHoSoVanBanDiComponent, {class: 'modal-lg'});
    (<ChenHoSoVanBanDiComponent>modalEdit.content).edit(
      id
    );
    (<ChenHoSoVanBanDiComponent>modalEdit.content).onClose.subscribe(result => {

    });

  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.searchVBD();

  }
  pageChangedDi(event: any): void {
    this.currentPageDi = event.page;
    this.searchVBDI();

  }
}
